// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.context-aware-sidebar {
  position: fixed;
  right: 0;
  /* Below navbar */
  width: 20%;
  height: calc(100vh - 60px);
  background: linear-gradient(135deg, rgba(32, 32, 32, 0.98), rgba(20, 20, 20, 0.98));
  border-left: 1px solid #3a3a3a;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  z-index: 1000;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.context-aware-sidebar.collapsed {
  width: 50px;
}

/* Sidebar Header */
.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: rgba(40, 40, 40, 0.9);
  border-bottom: 1px solid #3a3a3a;
  min-height: 60px;
  overflow: visible;
  position: relative;
  z-index: 1002;
}

/* Hide title and status when collapsed */
.context-aware-sidebar.collapsed .sidebar-header {
  justify-content: center;
  padding: 8px;
}

.context-aware-sidebar.collapsed .sidebar-title,
.context-aware-sidebar.collapsed .status-indicator-container {
  display: none;
}

.sidebar-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-icon {
  font-size: 24px;
}

.sidebar-title h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

.sidebar-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sidebar-toggle-btn {
  background: #2a2a2a;
  border: 1px solid #4a4a4a;
  color: #ffffff;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.sidebar-toggle-btn:hover {
  background: #3a3a3a;
  border-color: #5a5a5a;
}

.sidebar-toggle-btn:active {
  transform: scale(0.95);
}

/* Sidebar Content */
.sidebar-content {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px;
  scrollbar-width: thin;
  scrollbar-color: #4a4a4a #2a2a2a;
}

.sidebar-content::-webkit-scrollbar {
  width: 8px;
}

.sidebar-content::-webkit-scrollbar-track {
  background: #2a2a2a;
}

.sidebar-content::-webkit-scrollbar-thumb {
  background: #4a4a4a;
  border-radius: 4px;
}

.sidebar-content::-webkit-scrollbar-thumb:hover {
  background: #5a5a5a;
}

/* Panel Filter Tabs */
.panel-filters {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  padding: 8px;
  background: rgba(30, 30, 30, 0.8);
  border-radius: 6px;
  overflow-x: auto;
}

.filter-btn {
  flex: 1 1;
  min-width: 50px;
  padding: 8px 12px;
  background: #2a2a2a;
  border: 1px solid #3a3a3a;
  color: #aaaaaa;
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.filter-btn:hover {
  background: #3a3a3a;
  color: #ffffff;
  border-color: #4a4a4a;
}

.filter-btn.active {
  background: linear-gradient(135deg, #0066cc, #0052a3);
  color: #ffffff;
  border-color: #0066cc;
  box-shadow: 0 2px 8px rgba(0, 102, 204, 0.3);
}

/* Panel Common Styles */
.contextual-panel,
.diagnostic-panel,
.user-actions-panel {
  background: rgba(30, 30, 30, 0.9);
  border: 1px solid #3a3a3a;
  border-radius: 8px;
  margin-bottom: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.contextual-panel:hover,
.diagnostic-panel:hover,
.user-actions-panel:hover {
  border-color: #4a4a4a;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: rgba(40, 40, 40, 0.9);
  border-bottom: 1px solid #3a3a3a;
}

.panel-header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
}

.panel-badge {
  padding: 4px 8px;
  background: #2a2a2a;
  color: #aaaaaa;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.panel-badge.ai-badge {
  background: linear-gradient(135deg, #ff6b6b, #ee5a6f);
  color: #ffffff;
}

.panel-badge.interactive {
  background: linear-gradient(135deg, #4ecdc4, #44a9a0);
  color: #ffffff;
}

.panel-content {
  padding: 16px;
}

.panel-content.loading,
.panel-content.error,
.panel-content.empty {
  padding: 24px;
  text-align: center;
  color: #aaaaaa;
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #3a3a3a;
  border-top-color: #0066cc;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 12px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Sidebar Footer */
.sidebar-footer {
  padding: 12px 16px;
  background: rgba(25, 25, 25, 0.95);
  border-top: 1px solid #3a3a3a;
}

.footer-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #888888;
}

.info-icon {
  font-size: 14px;
}

.footer-info small {
  font-size: 11px;
}

/* Responsive Design */
@media (max-width: 1366px) {
  .context-aware-sidebar {
    width: 320px;
  }
}

@media (max-width: 1024px) {
  .context-aware-sidebar {
    width: 100%;
    right: -100%;
  }

  .context-aware-sidebar.expanded {
    right: 0;
  }
}

/* Accessibility */
.context-aware-sidebar button:focus,
.context-aware-sidebar a:focus {
  outline: 2px solid #0066cc;
  outline-offset: 2px;
}

/* Animation for panel appearance */
@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.contextual-panel,
.diagnostic-panel,
.user-actions-panel {
  animation: slideInRight 0.3s ease-out;
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,UAAU;EACV,0BAA0B;EAC1B,mFAAmF;EACnF,8BAA8B;EAC9B,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA,yCAAyC;AACzC;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,wBAAwB;AACxB;;;EAGE,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;EAGE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA,kBAAkB;AAClB;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;;EAGE,qCAAqC;AACvC","sourcesContent":[".context-aware-sidebar {\n  position: fixed;\n  right: 0;\n  /* Below navbar */\n  width: 20%;\n  height: calc(100vh - 60px);\n  background: linear-gradient(135deg, rgba(32, 32, 32, 0.98), rgba(20, 20, 20, 0.98));\n  border-left: 1px solid #3a3a3a;\n  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  z-index: 1000;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.context-aware-sidebar.collapsed {\n  width: 50px;\n}\n\n/* Sidebar Header */\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  background: rgba(40, 40, 40, 0.9);\n  border-bottom: 1px solid #3a3a3a;\n  min-height: 60px;\n  overflow: visible;\n  position: relative;\n  z-index: 1002;\n}\n\n/* Hide title and status when collapsed */\n.context-aware-sidebar.collapsed .sidebar-header {\n  justify-content: center;\n  padding: 8px;\n}\n\n.context-aware-sidebar.collapsed .sidebar-title,\n.context-aware-sidebar.collapsed .status-indicator-container {\n  display: none;\n}\n\n.sidebar-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.title-icon {\n  font-size: 24px;\n}\n\n.sidebar-title h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.sidebar-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sidebar-toggle-btn {\n  background: #2a2a2a;\n  border: 1px solid #4a4a4a;\n  color: #ffffff;\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.sidebar-toggle-btn:hover {\n  background: #3a3a3a;\n  border-color: #5a5a5a;\n}\n\n.sidebar-toggle-btn:active {\n  transform: scale(0.95);\n}\n\n/* Sidebar Content */\n.sidebar-content {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 16px;\n  scrollbar-width: thin;\n  scrollbar-color: #4a4a4a #2a2a2a;\n}\n\n.sidebar-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.sidebar-content::-webkit-scrollbar-track {\n  background: #2a2a2a;\n}\n\n.sidebar-content::-webkit-scrollbar-thumb {\n  background: #4a4a4a;\n  border-radius: 4px;\n}\n\n.sidebar-content::-webkit-scrollbar-thumb:hover {\n  background: #5a5a5a;\n}\n\n/* Panel Filter Tabs */\n.panel-filters {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n  padding: 8px;\n  background: rgba(30, 30, 30, 0.8);\n  border-radius: 6px;\n  overflow-x: auto;\n}\n\n.filter-btn {\n  flex: 1;\n  min-width: 50px;\n  padding: 8px 12px;\n  background: #2a2a2a;\n  border: 1px solid #3a3a3a;\n  color: #aaaaaa;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 11px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.filter-btn:hover {\n  background: #3a3a3a;\n  color: #ffffff;\n  border-color: #4a4a4a;\n}\n\n.filter-btn.active {\n  background: linear-gradient(135deg, #0066cc, #0052a3);\n  color: #ffffff;\n  border-color: #0066cc;\n  box-shadow: 0 2px 8px rgba(0, 102, 204, 0.3);\n}\n\n/* Panel Common Styles */\n.contextual-panel,\n.diagnostic-panel,\n.user-actions-panel {\n  background: rgba(30, 30, 30, 0.9);\n  border: 1px solid #3a3a3a;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.contextual-panel:hover,\n.diagnostic-panel:hover,\n.user-actions-panel:hover {\n  border-color: #4a4a4a;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);\n}\n\n.panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: rgba(40, 40, 40, 0.9);\n  border-bottom: 1px solid #3a3a3a;\n}\n\n.panel-header h4 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.panel-badge {\n  padding: 4px 8px;\n  background: #2a2a2a;\n  color: #aaaaaa;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.panel-badge.ai-badge {\n  background: linear-gradient(135deg, #ff6b6b, #ee5a6f);\n  color: #ffffff;\n}\n\n.panel-badge.interactive {\n  background: linear-gradient(135deg, #4ecdc4, #44a9a0);\n  color: #ffffff;\n}\n\n.panel-content {\n  padding: 16px;\n}\n\n.panel-content.loading,\n.panel-content.error,\n.panel-content.empty {\n  padding: 24px;\n  text-align: center;\n  color: #aaaaaa;\n}\n\n.loading-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #3a3a3a;\n  border-top-color: #0066cc;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 12px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Sidebar Footer */\n.sidebar-footer {\n  padding: 12px 16px;\n  background: rgba(25, 25, 25, 0.95);\n  border-top: 1px solid #3a3a3a;\n}\n\n.footer-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #888888;\n}\n\n.info-icon {\n  font-size: 14px;\n}\n\n.footer-info small {\n  font-size: 11px;\n}\n\n/* Responsive Design */\n@media (max-width: 1366px) {\n  .context-aware-sidebar {\n    width: 320px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .context-aware-sidebar {\n    width: 100%;\n    right: -100%;\n  }\n\n  .context-aware-sidebar.expanded {\n    right: 0;\n  }\n}\n\n/* Accessibility */\n.context-aware-sidebar button:focus,\n.context-aware-sidebar a:focus {\n  outline: 2px solid #0066cc;\n  outline-offset: 2px;\n}\n\n/* Animation for panel appearance */\n@keyframes slideInRight {\n  from {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.contextual-panel,\n.diagnostic-panel,\n.user-actions-panel {\n  animation: slideInRight 0.3s ease-out;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
